import React from 'react'
import { Link } from 'react-router-dom'
import { H1 } from '../../layout/mixins'

const Error = () => (
  <>
    <H1>Något gick fel</H1>
    <p>Tyvärr gick något fel när din ansökan skulle skickas in. Stänger ner detta fönstret och försök igen.</p>
  </>
)

export default Error
